import React, { createContext, useContext } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const queryClient = useQueryClient();

  const { data: user, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const { data } = await api.get('/auth/me');
      return data;
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    queryClient.setQueryData(['me'], data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } finally {
      queryClient.setQueryData(['me'], null);
      queryClient.clear();
    }
  };

  const role = user?.role;
  const canDelete = role === 'administrador';
  const canFinalize = role === 'administrador' || role === 'editor';
  const canManageUsers = role === 'administrador';

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, canDelete, canFinalize, canManageUsers }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
